var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-icon-wrap no-router"},[_c('img',{staticClass:"nav-icon",attrs:{"src":_vm.imgSrc}}),_c('div',{class:['status',_vm.status]}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }